const topics = [
  { title: '动作大片专区', desc: '肾上腺素飙升的视觉盛宴', icon: 'ri-fire-line', color: 'bg-primary-100 text-primary-600', count: '328部' },
  { title: '科幻巨制殿堂', desc: '震撼视效的未来世界探索', icon: 'ri-rocket-line', color: 'bg-accent-100 text-accent-700', count: '256部' },
  { title: '温情剧情精选', desc: '直击心灵的感人故事', icon: 'ri-heart-line', color: 'bg-pink-100 text-pink-600', count: '412部' },
  { title: '悬疑烧脑特辑', desc: '不到最后猜不透的真相', icon: 'ri-lightbulb-line', color: 'bg-amber-100 text-amber-700', count: '189部' },
  { title: '华语经典回顾', desc: '重温黄金年代的银幕记忆', icon: 'ri-vip-crown-line', color: 'bg-emerald-100 text-emerald-700', count: '503部' },
  { title: '动画奇幻世界', desc: '全家共享的欢乐时光', icon: 'ri-magic-line', color: 'bg-violet-100 text-violet-600', count: '291部' },
  { title: '纪录片精选集', desc: '真实世界的震撼纪录', icon: 'ri-earth-line', color: 'bg-cyan-100 text-cyan-700', count: '167部' },
  { title: '恐怖惊悚之夜', desc: '挑战胆量的刺激体验', icon: 'ri-ghost-line', color: 'bg-slate-100 text-slate-700', count: '145部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-secondary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-grid-line text-secondary-600 text-sm"></i>
              <span className="text-secondary-700 text-xs font-medium">分类浏览</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              专题合集
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              按类型探索海量高清影片，每个专题都精心甄选蓝光画质佳作
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {topics.map((topic) => (
              <a
                key={topic.title}
                href="#cards"
                className="group bg-background-50 border border-background-200/70 hover:border-primary-200/80 rounded-xl p-5 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer"
              >
                <div className={`w-11 h-11 rounded-xl ${topic.color} flex items-center justify-center mb-3.5`}>
                  <i className={`${topic.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-1.5 group-hover:text-primary-600 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-foreground-500 text-xs mb-2">{topic.desc}</p>
                <span className="text-foreground-400 text-xs">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}